import authentication from '../middleware/authentication'

const CallMonitoring = () => import(/* webpackChunkName: "static/js/chunks/callMonitoring" */'../../views/callMonitoring/index')

const CallMonitoringRoutes = [
  {
    path: '/call-monitoring',
    component: CallMonitoring,
    name: 'CallMonitoring',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  }
]

export default CallMonitoringRoutes
